import React, { useState } from "react";
import styles from "./question-accordion.module.scss";

function QuestionAccordion({ filterName, questions, isOpen, onHeaderClick, onClose }) {
    const toggleAccordion = () => {
        if (isOpen) {
            onClose();
        } else {
            onHeaderClick();
        }
    }
    return (
        <div className={styles.questionAccordion}>
            <div
                className={styles.questionAccordionHeader}
                onClick={toggleAccordion}
            >
                <h5>{filterName}</h5>
                <span>{isOpen ? "-" : "+"}</span>
            </div>
            <div
                className={`${styles.questionAccordionContent} ${
                    isOpen ? styles.openContent : ""
                }`}
            >
                {questions.map((question) => (
                    <div
                        id={`question-${question.Qid}`}
                        data-type={question.AnswerTypeName}
                        className={`question-item ${styles.questionAccordionItem}`}
                        key={question.Qid}
                        draggable="true"
                        onDragStart={(e) => {
                            e.dataTransfer.setData(
                                "text/plain",
                                JSON.stringify(question)
                            );
                        }}
                    >
                        {question.Question}
                    </div>
                ))}
            </div>
        </div>
    );
}

export default QuestionAccordion;